import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-brand-dark text-white pt-14 pb-16 px-4 overflow-hidden" data-id="element-23">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-blue/20 rounded-full blur-[100px] pointer-events-none" data-id="element-24"></div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-26">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-gold/20 text-brand-gold font-bold text-xs tracking-wider mb-4 border border-brand-gold/30" data-id="element-27">
            SISTEMA EXCLUSIVO PARA AGENTES INMOBILIARIOS
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black leading-tight mb-6" data-id="element-28">
            ¿Cuántas ventas inmobiliarias estás perdiendo…{' '}
            <span className="text-brand-gold" data-id="element-29">sin darte cuenta?</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-lg mx-auto mb-4" data-id="element-30">
          <a href="#comprar" className="block cursor-pointer" data-id="element-31">
            <img src="https://cdn.magicpatterns.com/uploads/opyCaXMRs3d8xa22keMh4i/Diseno_sin_titulo-64.png" alt="Kit Inmobiliario PRO" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-32" />
          </a>
          <p className="text-lg md:text-xl text-gray-300 font-heading font-bold mt-3" data-id="element-33">
            Sistema de Seguimiento de Leads y Clientes para Agentes
            Inmobiliarios
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full" data-id="element-34">
          <CTAButton data-id="element-35" />
          <p className="mt-3 text-gray-400 text-sm flex items-center justify-center gap-2" data-id="element-36">
            <span className="flex h-2 w-2 relative" data-id="element-37">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-38"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-39"></span>
            </span>
            Oferta especial disponible hoy
          </p>
        </motion.div>
      </div>
    </section>;
}